import { useContext, useEffect } from "react";
import AutoRefreshContext from "views/components/contexts/AutoRefreshContext";
const useOnRefresh = (fn) => {
  const context = useContext(AutoRefreshContext);
  useEffect(() => {
    if ((context == null ? void 0 : context.animationId) !== null && (context == null ? void 0 : context.animationId) !== void 0) {
      fn();
    }
  }, [context == null ? void 0 : context.animationId, fn]);
};
export default useOnRefresh;
